import { initializeApp } from 'firebase/app';
import { getFirestore } from 'firebase/firestore';
import { getAuth } from 'firebase/auth';

// Firebase web config is NOT secret — security comes from Firestore Rules + Auth
const firebaseConfig = {
  apiKey: "AIzaSyAlcDXHS6878_ifboCG81HP6jtBIrZPR_0",
  authDomain: "market-entry-pro.firebaseapp.com",
  projectId: "market-entry-pro",
  storageBucket: "market-entry-pro.firebasestorage.app",
  messagingSenderId: "437714371003",
  appId: "1:437714371003:web:6b907aca274baf2814449e",
};

const app = initializeApp(firebaseConfig);
export const db = getFirestore(app, 'default');
export const auth = getAuth(app);
